// export const formatPrice = (price) => {
//     return new Intl.NumberFormat('fr-FR', {
//         style: 'currency',
//         currency: "XOF"
//     }).format(price);
// }
export const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: "USD"
    }).format(price);
}